import { useMutation, useQuery } from '@tanstack/react-query';
import { IGlobalMail } from '../../Interfaces/IGlobalMail';
import { customFetcher } from '../useFetch';
import { GlobalMailInput } from '../../Interfaces/IGlobalMailInput';

export const useGetGlobalMails = () => {
  const { data: globalMails, isLoading: isLoadingGlobalMails } = useQuery<
    IGlobalMail[]
  >({
    queryKey: ['globalmail'],
    queryFn: () => customFetcher({ endpoint: '/globalmail' }),
  });

  return { globalMails, isLoadingGlobalMails };
};



export const useSendGlobalMail = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (input: GlobalMailInput) =>
      customFetcher({
        endpoint: "/globalmail",
        method: "POST",
        body: input,
      }),
  });

  return {
    sendGlobalMail: mutateAsync,
    isPendingSendGlobalMail: isPending,
  };
};
